// Team Hauler Notifications Actions
export const REQUEST_CURRENT_HAULER_TEAM_MEMBER_NOTIFICATIONS_ACTION = 'REQUEST_CURRENT_HAULER_TEAM_MEMBER_NOTIFICATIONS_ACTION'
export const RECEIVE_CURRENT_HAULER_TEAM_MEMBER_NOTIFICATIONS_SUCCESS = 'RECEIVE_CURRENT_HAULER_TEAM_MEMBER_NOTIFICATIONS_SUCCESS'
export const RECEIVE_CURRENT_HAULER_TEAM_MEMBER_NOTIFICATIONS_FAILURE = 'RECEIVE_CURRENT_HAULER_TEAM_MEMBER_NOTIFICATIONS_FAILURE'

// Team Hauler Actions for Activate and Deactivate
export const REQUEST_HAULER_TEAM_MEMBER_ACTIVATE_ACTION = 'REQUEST_HAULER_TEAM_MEMBER_ACTIVATE_ACTION'
export const RECEIVE_HAULER_TEAM_MEMBER_ACTIVATE_SUCCESS = 'RECEIVE_HAULER_TEAM_MEMBER_ACTIVATE_SUCCESS'
export const RECEIVE_HAULER_TEAM_MEMBER_ACTIVATE_FAILURE = 'RECEIVE_HAULER_TEAM_MEMBER_ACTIVATE_FAILURE'

export const REQUEST_HAULER_TEAM_MEMBER_DEACTIVATE_ACTION = 'REQUEST_HAULER_TEAM_MEMBER_DEACTIVATE_ACTION'
export const RECEIVE_HAULER_TEAM_MEMBER_DEACTIVATE_SUCCESS = 'RECEIVE_HAULER_TEAM_MEMBER_DEACTIVATE_SUCCESS'
export const RECEIVE_HAULER_TEAM_MEMBER_DEACTIVATE_FAILURE = 'RECEIVE_HAULER_TEAM_MEMBER_DEACTIVATE_FAILURE'
